module.exports = "https://la-static.vkplay.ru/promo/universal/img/logo-astrum.cd60bcc8.svg";